import { IdLibelleModel } from "./id.libelle.model";

export class IdLibelleCleModel extends IdLibelleModel {
	cle: string;
	actif: boolean;
}
